/*
 * VOLTAJE — revelado de contenido al hacer scroll.
 * Marca solo los elementos que empiezan fuera de la pantalla y los muestra una sola vez
 * al entrar en ella. Los estilos están en voltaje-motion.css.
 */
(() => {
  // En el editor de Shopify no se anima: estorbaría al editar.
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;

  const main = document.getElementById('MainContent');
  if (!main) return;

  const STAGGER_MS = 70; // separación entre elementos de un mismo grupo
  const MAX_STAGGER_STEPS = 5; // el último de un grupo nunca espera más de 350 ms
  const WIPE_DURATION_MS = 1800; // duración de la imagen dentro de la cortinilla
  const foldLine = window.innerHeight * 0.9;
  const targets = [];

  const mark = (el, kind, step) => {
    // Lo que ya se ve al cargar no se esconde: evita parpadeos.
    if (el.getBoundingClientRect().top < foldLine) return;
    el.dataset.vjReveal = kind;
    const delay = Math.min(step, MAX_STAGGER_STEPS) * STAGGER_MS;
    if (delay) el.style.setProperty('--vj-delay', `${delay}ms`);
    targets.push(el);
  };

  // La primera sección (el héroe) ya tiene su propia animación de entrada.
  const sections = [...main.querySelectorAll(':scope > .shopify-section')].slice(1);

  sections.forEach((section) => {
    // La cinta de valores ya está en movimiento; no se le añade nada.
    if (section.querySelector('marquee-component')) return;

    // Tarjetas: las del carrusel (slides) o las de la rejilla.
    const slides = section.querySelectorAll('.resource-list__slide');
    const cards = slides.length ? slides : section.querySelectorAll('.resource-list__item');
    const isCollectionList = !!section.querySelector('[class*="collection-card"]');

    // Textos y botones que no están dentro de una tarjeta.
    // [data-vj-rise]: textos de secciones propias de VOLTAJE que no usan los bloques de Horizon.
    const copy = [
      ...section.querySelectorAll('.text-block, .button, .button-secondary, .button-unstyled, [data-vj-rise]'),
    ].filter(
      (el) => !el.closest('.resource-list__slide, .resource-list__item') && !el.parentElement.closest('.text-block')
    );

    // Imágenes sueltas (bloque "Imagen" de Horizon): misma cortinilla que las colecciones.
    const images = [...section.querySelectorAll('.image-block')].filter(
      (el) => !el.closest('.resource-list__slide, .resource-list__item')
    );

    copy.forEach((el, i) => mark(el, 'rise', i));
    cards.forEach((el, i) => mark(el, isCollectionList ? 'wipe' : 'rise', i + 1));
    images.forEach((el, i) => mark(el, 'wipe', i + 1));
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        if (!isIntersecting) return;
        target.dataset.vjVisible = '';
        observer.unobserve(target); // una sola vez: no se repite al volver a pasar

        if (target.dataset.vjReveal === 'wipe') {
          const delay = parseInt(target.style.getPropertyValue('--vj-delay'), 10) || 0;
          setTimeout(() => {
            target.dataset.vjDone = '';
          }, WIPE_DURATION_MS + delay);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  targets.forEach((el) => observer.observe(el));
})();

/*
 * Parallax de las portadas con "Efecto parallax en la foto" (sections/hero.liquid → vj_parallax).
 * La foto va ampliada un poco y se desplaza más despacio que la página. El scroll de la tienda
 * va dentro de un contenedor, así que se escucha en fase de captura y se mide con getBoundingClientRect.
 */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const heroes = [...document.querySelectorAll('.hero--vj-parallax')];
  if (!heroes.length) return;

  const RANGE = 0.08; // desplazamiento máximo: 8 % del alto de la sección (la foto va al 118 %)
  const visible = new Set();
  let frame = 0;

  const update = () => {
    frame = 0;
    const viewport = window.innerHeight;
    visible.forEach((hero) => {
      const rect = hero.getBoundingClientRect();
      // -1 cuando la sección asoma por abajo, 1 cuando sale por arriba
      const progress = ((viewport - rect.top) / (viewport + rect.height)) * 2 - 1;
      hero.style.setProperty('--vj-parallax-y', `${(progress * rect.height * RANGE).toFixed(1)}px`);
    });
  };

  const request = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) visible.add(target);
      else visible.delete(target);
    });
    request();
  });

  heroes.forEach((hero) => {
    hero.dataset.vjParallax = '';
    observer.observe(hero);
  });
  document.addEventListener('scroll', request, { capture: true, passive: true });
  window.addEventListener('resize', request);
})();
